var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import { BoldHeading, NoBr, StyledBody, Wrapper } from './style';
import Grid from '@lendi-ui/grid';
import { Form } from 'react-final-form';
import { formattedPhoneNumber } from '../../../utils';
import { VerifyOtpField } from '../FieldComponents';
import { LoadingButton } from '../atoms/LoadingButton';
import { AlertError } from '../AlertError';
import { useSession } from '@lendi/lala-react';
import { WrongNumber } from '../WrongNumber';
import { ResendAction } from '../ResendComponent';
import { validateOtpInput } from '../../../utils/validateInput';
import { AuthTypes, SmartChatTypes } from '../SmartChat/states';
import { ChatEventName, EventCategory, analytics } from '../../../analytics';
import { SmartExperimentCheckpoint } from '../SmartChat/states/state/types';
import { useError } from '../../../providers/ErrorProvider/context';
import { handleAuthError } from '../../../utils/authError';
import { useBootstrappedChatState } from '../../../providers/ChatBootstrapperProvider';
import { Devider } from '../SmartChatExperiment1/style';
export var Verify = function (_a) {
    var chatState = _a.chatState, chatDispatch = _a.chatDispatch, authState = _a.authState, authDispatch = _a.authDispatch, experimentStateHandler = _a.experimentStateHandler, experiment1 = _a.experiment1;
    var _b = useSession(), sendCode = _b.sendCode, verifyCode = _b.verifyCode;
    var setChatInputFields = useBootstrappedChatState().setChatInputFields;
    var onException = useError().onException;
    var _c = useState(false), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(false), wrongNumberClicked = _d[0], setWrongNumberClicked = _d[1];
    var phoneNumber = chatState.phoneNumber, email = chatState.email, firstName = chatState.firstName, leadId = chatState.leadId;
    var error = authState.error;
    var handleWrongNumberClick = function () {
        resetAuthError();
        chatDispatch({
            type: SmartChatTypes.NEXT_EXPERIMENT_ONE_SMART_STATE,
            payload: SmartExperimentCheckpoint.ON_SIGN_IN_CHECK,
        });
        experimentStateHandler();
        setWrongNumberClicked(true);
        chatDispatch({ type: SmartChatTypes.SIGN_IN_SUBMITTED, payload: false });
        chatDispatch({ type: SmartChatTypes.START_STEP_BUTTON_CLICKED, payload: false });
    };
    var handleResendAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    authDispatch({ type: AuthTypes.SEND_CODE });
                    return [4 /*yield*/, sendCode(phoneNumber)];
                case 1:
                    _a.sent();
                    authDispatch({ type: AuthTypes.SENT_CODE });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    authDispatch({ type: AuthTypes.ERROR, payload: error_1 });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var code, valid, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    chatDispatch({ type: SmartChatTypes.SIGN_IN_SUBMITTED, payload: false });
                    chatDispatch({ type: SmartChatTypes.START_STEP_BUTTON_CLICKED, payload: false });
                    setIsLoading(true);
                    code = values.code;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    chatDispatch({ type: SmartChatTypes.UPDATE_CODE, payload: values.code });
                    authDispatch({ type: AuthTypes.VERIFY_CODE });
                    return [4 /*yield*/, verifyCode({
                            phone: phoneNumber,
                            code: code,
                            email: email,
                            leadId: leadId,
                            firstName: firstName,
                        })];
                case 2:
                    valid = (_a.sent()).valid;
                    if (valid) {
                        authDispatch({ type: AuthTypes.VERIFIED_CODE, payload: true });
                    }
                    analytics({
                        event_name: ChatEventName.OTP_ENTERED,
                        category: EventCategory.CHAT,
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    handleAuthError({ error: error_2, authDispatch: authDispatch, onException: onException });
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var resetAuthError = function () {
        authDispatch({ type: AuthTypes.ERROR, payload: null });
    };
    var onInputChange = function (e) {
        var _a = e.target || {}, name = _a.name, value = _a.value;
        setChatInputFields(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Devider, { hasMargin: true }),
        React.createElement(Wrapper, null,
            React.createElement(BoldHeading, { color: "shade.1000", mb: "xs", align: "center" }, "Verify to continue"),
            React.createElement(StyledBody, { color: "shade.1000", align: "center", mt: "md", mb: "xs" },
                "Your one-time passcode has been sent to",
                React.createElement(NoBr, { className: "fs-exclude" },
                    formattedPhoneNumber(phoneNumber),
                    "."),
                React.createElement("br", null),
                React.createElement(WrongNumber, { onClick: handleWrongNumberClick, wrongNumberClicked: wrongNumberClicked }, "Wrong number?")),
            React.createElement(Grid, { halign: "center" },
                React.createElement(Grid.Unit, { size: 1 },
                    React.createElement(Form, { validate: function (values) { return validateOtpInput(values, wrongNumberClicked); }, onSubmit: onSubmit }, function (_a) {
                        var handleSubmit = _a.handleSubmit, invalid = _a.invalid;
                        return (React.createElement("form", { style: { textAlign: 'center' }, onSubmit: handleSubmit },
                            React.createElement(VerifyOtpField, { autoFocus: true, error: error, resetAuthError: resetAuthError, isDisabled: wrongNumberClicked, onInputChange: onInputChange }),
                            experiment1 && React.createElement(AlertError, { error: error }),
                            React.createElement(LoadingButton, { type: "submit", mt: "xxs", isFullWidth: true, variant: "primary", "data-testid": "sign-in", isDisabled: invalid || wrongNumberClicked, loading: isLoading }, "VERIFY")));
                    }))),
            React.createElement(ResendAction, { handleClick: handleResendAction, wrongNumberClicked: wrongNumberClicked, mt: "lg" }))));
};
//# sourceMappingURL=index.js.map